export default "__VITE_ASSET__BVmwAfoO__"